const axios = require("axios");
/* NodeJS */
const url = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL;
const urlV5 = url.replace("v1", "v5");

module.exports = {
  getAvailability: (accessToken, productId, propertyUid) =>
    axios({
      method: "GET",
      url: `${urlV5}/fixed_inventories/availabilities`,
      params: {
        access_token: accessToken,
        product_id: productId,
        property_uid: propertyUid
      }
    })
};
